const TableContent = [
  {
    RankNo: "#1",
    RankImg: "Person-12.png",
    RankName: "Stuw dale",
    Genre: "Genre 01",
    Unique: "87",
    UniqueCollector: "87",
    PrimarySale: "100 Eth",
    SecondarySale: "100 Eth",
  },
  {
    RankNo: "#2",
    RankImg: "Person-13.png",
    RankName: "Phoenix Baker",
    Genre: "Genre 02",
    Unique: "36",
    UniqueCollector: "36",
    PrimarySale: "100 Eth",
    SecondarySale: "100 Eth",
  },
  {
    RankNo: "#3",
    RankImg: "Person-14.png",
    RankName: "Lana Steiner",
    Genre: "Genre 03",
    Unique: "55",
    UniqueCollector: "55",
    PrimarySale: "100 Eth",
    SecondarySale: "100 Eth",
  },
  {
    RankNo: "#4",
    RankImg: "Person-15.png",
    RankName: "Demi Wilkinson",
    Genre: "Genre 07",
    Unique: "48",
    UniqueCollector: "48",
    PrimarySale: "100 Eth",
    SecondarySale: "100 Eth",
  },
  {
    RankNo: "#5",
    RankImg: "Person-16.png",
    RankName: "Natali Craig",
    Genre: "Genre 01",
    Unique: "33",
    UniqueCollector: "33",
    PrimarySale: "100 Eth",
    SecondarySale: "100 Eth",
  },
  {
    RankNo: "#6",
    RankImg: "Person-17.png",
    RankName: "Drew Cano",
    Genre: "Genre 01",
    Unique: "11",
    UniqueCollector: "11",
    PrimarySale: "100 Eth",
    SecondarySale: "100 Eth",
  },
  {
    RankNo: "#7",
    RankImg: "Person-18.png",
    RankName: "Andi Lane",
    Genre: "Genre 07",
    Unique: "20",
    UniqueCollector: "20",
    PrimarySale: "100 Eth",
    SecondarySale: "100 Eth",
  },
  {
    RankNo: "#8",
    RankImg: "Person-19.png",
    RankName: "Kate Morrison",
    Genre: "Genre 01",
    Unique: "50",
    UniqueCollector: "50",
    PrimarySale: "100 Eth",
    SecondarySale: "100 Eth",
  },
];
export { TableContent };
